export const WastesChoises = [
  { id: "dib", name: "Déchets résiduels" },
  { id: "emb_pap", name: "Emballages et papiers" },
  { id: "verre", name: "Verres" },
  { id: "carton", name: "Cartons" },
  { id: "bio_dechet", name: "Bio déchets" },
];

export const WastesChoisesLabels: Record<string, string> = WastesChoises.reduce(
  (acc, { id, name }) => ({ ...acc, [id]: name }),
  {}
);